import { createContext, useContext } from 'react';

// ----------------------------------------------------------------------

// Contexto usado quando o ChatWindow é aberto dentro de um modal/drawer
// (ex.: DrawerChatWhatsapp). Permite que o ChatHeader renderize o botão
// "voltar" apenas nesse cenário, sem alterar o ChatWindow.
export const ChatModalContext = createContext(null);

export function useChatModal() {
    return useContext(ChatModalContext);
}
